<template>
  <div class="bank-info">
    <BaseHeaderBar title="Informasi Bank" :showCustomerService="false" :showBackButton="true" color="#333" bgColor="#FFF" />
    <form class="form-content" @submit.prevent="onSubmit">
      <div class="input-block select-block">
        <input type="text" readonly :value="bankName" placeholder="Nama Bank" @click="openBankPicker">
        <img src="@/assets/img/arrow-down.png" class="arrow-down">
        <van-popup v-model="showPicker" round position="bottom" @closed="onBankPickerClosed">
          <van-picker show-toolbar :columns="columns" value-key="bank_name" :default-index="defaultIndex" cancel-button-text="Batal" confirm-button-text="Yakin" @cancel="showPicker = false" @confirm="onConfirm" />
        </van-popup>
      </div>
      <div class="input-block">
        <input v-model.trim="account" type="tel" minlength="10" maxlength="20" placeholder="Rekening Bank" @focus="startFieldTracking('account', account)" @blur="finishFieldTracking('account', account)">
      </div>
      <div class="input-block">
        <input v-model.trim="reAccount" type="tel" minlength="10" maxlength="20" placeholder="Konfirmasi rekening bank" @focus="startFieldTracking('reAccount', reAccount)" @blur="finishFieldTracking('reAccount', reAccount)">
      </div>
      <button type="submit" class="submit-btn-another">Submit</button>
    </form>
  </div>
</template>

<script>
import Vue from 'vue'
import { Popup, Picker, Toast } from 'vant'
import { validateBankAccount } from '@/utils/validator'
import request from '@/utils/request'
import webviewBack from '@/mixins/webviewBack'
import {
  createFormTracking,
  finishFormFieldTracking,
  getFormTrackingData,
  startFormFieldTracking
} from '@/utils/formTracking'

Vue.use(Popup)
Vue.use(Picker)

const trackingFieldMap = {
  bankName: 'bankname',
  account: 'bankcard',
  reAccount: 'confirmbankcard'
}

export default {
  name: 'BankInfo',
  mixins: [webviewBack],
  data () {
    return {
      bankName: '',
      account: '',
      reAccount: '',
      abbrBankName: '',
      columns: [],
      showPicker: false,
      defaultIndex: 0,
      flag: false,
      tracking: createFormTracking(trackingFieldMap)
    }
  },
  created () {
    this.getBankList()
  },
  methods: {
    startFieldTracking (field, value) {
      startFormFieldTracking(this.tracking, field, value)
    },
    finishFieldTracking (field, value) {
      finishFormFieldTracking(this.tracking, field, value)
    },
    getTrackingData () {
      return getFormTrackingData(this.tracking, trackingFieldMap)
    },
    getBankList () {
      request.post('badrnkInfoPage')
        .then(res => {
          this.bankName = res.badrnkName
          this.account = this.reAccount = res.badrnkAccount
          const bankList = res.badrnk_list || []
          this.defaultIndex = Math.floor(bankList.length / 2)
          this.columns = res.badrnk_list
          this.abbrBankName = res.gadrteID
        })
    },
    validate () {
      if (!this.bankName) {
        Toast('Silakan pilih nama bank')
        return false
      }
      if (!this.account) {
        Toast('Silakan masukkan nomor rekening bank')
        return false
      }
      if (!this.reAccount) {
        Toast('Silakan konfirmasi nomor rekening bank')
        return false
      }
      if (!validateBankAccount(this.account)) {
        Toast('Format nomor rekening bank salah')
        return false
      }
      if (this.account !== this.reAccount) {
        Toast('Kedua nomor rekening yang dimasukkan tidak sama')
        return false
      }
      return true
    },
    onSubmit () {
      if (!this.validate()) return
      if (this.flag) return
      this.flag = true
      const trackingData = this.getTrackingData()
      const postData = {
        badrnkName: this.bankName,
        gadrteID: this.abbrBankName,
        badrnkAccount: this.account
      }
      request.post('badrnkInfosubmit', postData)
        .then(() => {
          return request.post('bankInfoTracking', trackingData).catch(() => false)
        })
        .then(() => {
          Toast('Pembaruan data bank berhasil')
          this.$router.back()
        }).finally(() => {
          this.flag = false
        })
    },
    openBankPicker () {
      this.startFieldTracking('bankName', this.bankName)
      this.showPicker = true
    },
    onConfirm (value) {
      this.bankName = value.bank_name
      this.abbrBankName = value.gate_id
      this.finishFieldTracking('bankName', this.bankName)
      this.showPicker = false
    },
    onBankPickerClosed () {
      this.finishFieldTracking('bankName', this.bankName)
      this.showPicker = false
    }
  }
}
</script>

<style scoped lang="less">
.bank-info {
  min-height: 100vh;
  background-color: @body-bg-color;
}

.form-content {
  margin-top: 24px;
  padding-left: 30px;
  padding-right: 30px;
}

.input-block {
  &:nth-child(n+2) {
    margin-top: 16px;
  }

  input {
    display: block;
    width: 100%;
    height: 88px;
    line-height: 88px;
    border: 2px solid #242D3C;
    border-radius: 8px;
    padding-left: 16px;
    box-sizing: border-box;
    font-size: 30px;
    color: #333;
    background-color: #FFF;

    &::placeholder {
      font-size: 26px;
      color: #D1D2DD;
    }
  }
}

.select-block {
  position: relative;

  .arrow-down {
    position: absolute;
    top: 50%;
    right: 16px;
    width: 23px;
    height: 18px;
    transform: translateY(-50%);
  }
}

.submit-btn-another {
  .submit-bg-btn;
  margin-top: 80px;
}
</style>
